<script>
  export let openPanel;
  export let currentPhotoData;
  export let setAllTargetsVisited;
  export let isDetailsVisible;
  export let isQuizzVisible;
  export let isAboutVisible;
  export let disableZoomHint;
  let hasZooomed = false;
  import * as THREE from "three";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
  import * as dat from "dat.gui";
  import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
  import svelteHammer from "svelte-hammer";
  // import photoData from "./data.json";

  //GUI, DEBUG
  const gui = new dat.GUI();
  gui.close();
  // Hide dat GUI for prod!
  gui.__proto__.constructor.toggleHide();

  // clock
  const clock = new THREE.Clock();

  // CONSTs
  // Material opacity for the 3d target
  // update here to see the model!
  const isModelVisible = false;
  const MAT_OPACITY = isModelVisible ? 0.7 : 0;
  // const currentPhotoData = photoData[currentPhoto];
  let isImageWiggling = false;
  let wiggleIndex = false;
  const CANVAS_WIDTH = 1024;
  let HIGHGLIGHT_OPACITY = 0;
  let HIGHLIGHT_OPACITY_STEP = 0.007;
  const HIGHLIGHT_VISITED_OPACITY = 0;
  let CANVAS_INITIATED = false;
  let BLINK_ON = false;
  let IMAGE_APPEARED = false;
  let APPARITION_FRAME_COUNT = 0;
  const APPARITION_FRAMES = 100;
  const CAMERA_INIT_POSZ = 500;
  const CAMERA_BASE_POSZ = currentPhotoData.scene_settings.camera.position.z;
  const DISPLACEMENT_SCALE = currentPhotoData.scene_settings.displacement_scale;
  const IMG_FOLDER = currentPhotoData.folder;
  const BASE_IMG = currentPhotoData.image;
  const DEPTH_IMG = currentPhotoData.displacement_map;

  const TARGETS = [];
  currentPhotoData.objects.forEach((object) => {
    TARGETS.push(object);
  });

  //RAYCASTER
  const raycaster = new THREE.Raycaster();

  // SETUP
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff);

  // IMAGES
  let backgroundImage;
  let highlights = {};

  // TARGETS
  let charTarget;
  //let targetObjects = [];
  const modelLoader = new GLTFLoader();

  const camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  );
  const renderer = new THREE.WebGLRenderer();
  const controls = new OrbitControls(camera, renderer.domElement);

  //TEXTURES
  let material;
  let charMaterial;
  const loader = new THREE.TextureLoader();
  //const heightTexture = loader.load("./images/depth01.png");

  const heightTexture = loader.load(
    "./all_content/" + IMG_FOLDER + "/" + DEPTH_IMG
  );

  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  const canvasTexture = new THREE.CanvasTexture(canvas);

  // SETUP
  setupScene();
  setupLights();
  setupMaterials();
  setupCamera();
  setupTargets();
  initCanvas();

  // START DRAWING LOOP!
  animate();

  let plane;

  function startScene() {
    const geometry = new THREE.PlaneGeometry(5, 5, 150, 150);
    plane = new THREE.Mesh(geometry, material);
    plane.name = "background";
    scene.add(plane);
  }

  // ANIMATE
  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    renderer.setClearColor(0xffffff, 0);
    controls.update();
    if (CANVAS_INITIATED == true) {
      updateTargets();
    }
    blink();
    if (IMAGE_APPEARED == false) {
      imageApparition();
    }

    if (isImageWiggling) {
      wiggleImage();
    }
  }

  const registerClick = (e) => {
    if (isQuizzVisible || isDetailsVisible || isAboutVisible) {
      return;
    }
    let mouse = {};

    // If it's a touch
    if (e.targetTouches) {
      mouse = {
        x: (e.targetTouches[0].clientX / window.innerWidth) * 2 - 1,
        y: -(e.targetTouches[0].clientY / window.innerHeight) * 2 + 1,
      };
      // If it's a click
    } else if (e.clientX) {
      mouse = {
        x: (e.clientX / window.innerWidth) * 2 - 1,
        y: -(e.clientY / window.innerHeight) * 2 + 1,
      };
      // If it's hammer.js
    } else if (e.center) {
      mouse = {
        x: (e.center.x / window.innerWidth) * 2 - 1,
        y: -(e.center.y / window.innerHeight) * 2 + 1,
      };
    }

    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(scene.children, true);
    intersects.forEach((object) => {
      TARGETS.forEach((target, i) => {
        if (object.object.name == target.name) {
          openPanel(target);
          target.visited = true;
          updateTargets();
        }
      });
    });
  };

  function initCanvas() {
    const hammerTime = new Hammer(window);
    hammerTime.on("tap", function (e) {
      registerClick(e);
    });

    hammerTime.get("pinch").set({ enable: true });

    hammerTime.on("pinch", function (e) {
      if (hasZooomed) {
        return;
      } else {
        disableZoomHint();
      }
    });

    canvas.id = "backgroundlayer";
    canvas.width = CANVAS_WIDTH;
    canvas.height = CANVAS_WIDTH;
    document.body.appendChild(canvas);
    backgroundImage = new Image();
    backgroundImage.onload = function () {
      ctx.globalAlpha = 1;
      ctx.drawImage(backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);

      startScene();
      window.setTimeout(() => {
        BLINK_ON = true;
      }, 2000);
      updateCanvas();
    };
    backgroundImage.src = "./all_content/" + IMG_FOLDER + "/" + BASE_IMG;
  }

  function updateCanvas() {
    TARGETS.forEach((target) => {
      const targetModels = target.model_targets;
      targetModels.forEach((model, i) => {
        const img = new Image();
        img.onload = function () {
          var ctx = canvas.getContext("2d");
          ctx.globalAlpha = HIGHGLIGHT_OPACITY;
          ctx.drawImage(img, 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
          canvasTexture.needsUpdate = true;
          if (!highlights[target.name]) {
            highlights[target.name] = [];
          }
          highlights[target.name][i] = img;
        };
        img.src = "./all_content/" + IMG_FOLDER + "/" + model.highlight_img;
      });
    });

    CANVAS_INITIATED = true;
  }

  function blink() {
    if (BLINK_ON == true) {
      HIGHGLIGHT_OPACITY += HIGHLIGHT_OPACITY_STEP;

      if (HIGHGLIGHT_OPACITY >= 0.8) {
        HIGHLIGHT_OPACITY_STEP *= -1;
      } else if (HIGHGLIGHT_OPACITY <= 0) {
        HIGHLIGHT_OPACITY_STEP *= -1;
        HIGHGLIGHT_OPACITY = 0;
        BLINK_ON = false;
        window.setTimeout(() => {
          BLINK_ON = true;
        }, 3000);
      }
    } else {
      HIGHGLIGHT_OPACITY = 0;
    }
  }

  function imageApparition() {
    if (camera.position.z > CAMERA_BASE_POSZ) {
      const DIFF_POSITIONS_CAM = CAMERA_INIT_POSZ - CAMERA_BASE_POSZ;
      const CURRENT_LINEAR_VALUE =
        (DIFF_POSITIONS_CAM / APPARITION_FRAMES) * APPARITION_FRAME_COUNT;
      const REMAPPED_CURRENT_LINEAR_VALUE =
        CURRENT_LINEAR_VALUE / DIFF_POSITIONS_CAM;
      const CURRENT_EASED_VALUE =
        REMAPPED_CURRENT_LINEAR_VALUE *
        (2 - REMAPPED_CURRENT_LINEAR_VALUE) *
        DIFF_POSITIONS_CAM;
      const CURRENT_EASED_VALUE2 =
        (Math.pow(REMAPPED_CURRENT_LINEAR_VALUE - 1, 3) + 1) *
        DIFF_POSITIONS_CAM;
      const CURRENT_FINAL_VALUE = CAMERA_INIT_POSZ - CURRENT_LINEAR_VALUE;
      //console.log(CURRENT_EASED_VALUE2);
      camera.position.z = CAMERA_INIT_POSZ - CURRENT_EASED_VALUE2;

      APPARITION_FRAME_COUNT++;
      //console.log(APPARITION_FRAME_COUNT);
    } else {
      camera.position.z = CAMERA_BASE_POSZ;
      IMAGE_APPEARED = true;
      window.setTimeout(() => {
        isImageWiggling = true;
      }, 250);
    }
  }

  function wiggleImage() {
    wiggleIndex++;
    // TODO: Move the image with a gsap value!
    // TODO: move the image from left to right to show that it is 3d
    const elapsedTime = clock.getElapsedTime();
    plane.rotation.y = Math.sin(elapsedTime * 2) / 10;
    // plane.rotation.x = Math.sin(elapsedTime * 2) / 20;
    if (wiggleIndex == 185) isImageWiggling = false;
  }

  function updateTargets() {
    ctx.globalAlpha = 1;
    let visitedTargets = 0;
    ctx.drawImage(backgroundImage, 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
    TARGETS.forEach((target, i) => {
      ctx.filter = "none";
      if (target.visited) {
        ctx.globalAlpha = HIGHLIGHT_VISITED_OPACITY;
        ctx.filter = "grayscale(100%)";
        highlights[target.name].forEach((highlight) => {
          ctx.drawImage(highlight, 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
        });
        // ctx.drawImage(
        //   highlights[target.name],
        //   0,
        //   0,
        //   CANVAS_WIDTH,
        //   CANVAS_WIDTH
        // );
        ctx.filter = "none";
        visitedTargets++;
      } else {
        ctx.filter = "none";
        ctx.globalAlpha = HIGHGLIGHT_OPACITY;
        if (highlights[target.name]) {
          highlights[target.name].forEach((highlight) => {
            ctx.drawImage(highlight, 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
          });
        }
        ctx.globalAlpha = 0;
        ctx.filter = "none";
      }
    });
    canvasTexture.needsUpdate = true;

    ctx.globalAlpha = 1 - APPARITION_FRAME_COUNT / APPARITION_FRAMES;
    //console.log(APPARITION_FRAME_COUNT/APPARITION_FRAMES)
    ctx.fillStyle = "rgb(255, 255, 255)";
    ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
    if (visitedTargets == TARGETS.length) {
      // wait 500 ms, otherwise we see the quizz button appear before the panel is open.
      window.setTimeout(() => {
        setAllTargetsVisited();
      }, 500);
    }
    // ctx.globalAlpha = opacity;
    // if (grayScale) ctx.filter = "grayscale(100%)";
    // ctx.drawImage(highlights[0], 0, 0, CANVAS_WIDTH, CANVAS_WIDTH);
    // canvasTexture.needsUpdate = true;
    // ctx.filter = "none";
  }

  function setupScene() {
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);
    // Add touch listener to the canvas
  }

  function setupCamera() {
    //CAM AND ORBIT CONTROLS
    const CONTROLS = currentPhotoData.scene_settings;
    camera.position.x = CONTROLS.camera.position.x;
    camera.position.y = CONTROLS.camera.position.y;
    camera.position.z = CAMERA_INIT_POSZ;

    const camPositionImage01X = CONTROLS.character_focus_position.x;
    const camPositionImage01Y = CONTROLS.character_focus_position.y;
    const camPositionImage01Z = CONTROLS.character_focus_position.z;

    const characterPosition = new THREE.Vector3(
      camPositionImage01X,
      camPositionImage01Y,
      camPositionImage01Z
    );

    controls.minDistance = CONTROLS.controls.min_distance;
    controls.maxDistance = CONTROLS.controls.max_distance;
    controls.minAzimuthAngle = CONTROLS.controls.min_azimuth_angle;
    controls.maxAzimuthAngle = CONTROLS.controls.max_azimuth_angle;
    controls.minPolarAngle = CONTROLS.controls.min_polar_angle;
    controls.maxPolarAngle = CONTROLS.controls.max_polar_angle;

    controls.target = characterPosition;
    const camTarget = gui.addFolder("Camera Target");
    camTarget.add(controls.target, "x").min(-1).max(1).step(0.0001);
    camTarget.add(controls.target, "y").min(-1).max(1).step(0.0001);
    camTarget.add(controls.target, "z").min(-1).max(1).step(0.0001);
    camTarget.open();
    const camPosition = gui.addFolder("Camera Position");
    camPosition.add(camera.position, "x").min(-1).max(1).step(0.0001);
    camPosition.add(camera.position, "y").min(-1).max(1).step(0.0001);
    camPosition.add(camera.position, "z").min(0).max(7).step(0.0001);
    camPosition.open();
  }

  function setupLights() {
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);

    const light = new THREE.PointLight(0xffffff, 0.5);
    light.position.x = 2;
    light.position.y = 3;
    light.position.z = 4;
    scene.add(light);
  }

  function setupMaterials() {
    material = new THREE.MeshStandardMaterial({
      map: canvasTexture,
    });

    material.displacementMap = heightTexture;
    material.displacementScale = DISPLACEMENT_SCALE;

    gui.add(material, "displacementScale").min(-2.43).max(0).step(0.0001);
    gui.add(material, "wireframe");
  }

  function setupTargets() {
    TARGETS.forEach((target, i) => {
      target.model_targets.forEach((model) => {
        // console.log("load model");
        modelLoader.load(
          "./all_content/" + IMG_FOLDER + "/" + model.name,
          function (gltf) {
            // console.log("model loaded");
            const currentTarget = gltf.scene;
            // console.log("GLTF =", gltf);
            scene.add(currentTarget);
            currentTarget.name = TARGETS[i].name;
            if (currentTarget.children[0].children.length > 0) {
              currentTarget.children[0].children[0].name = TARGETS[i].name;
              currentTarget.children[0].children[0].material.color.set(
                0xfff500
              );
              currentTarget.children[0].children[0].material.transparent = true;
              currentTarget.children[0].children[0].material.opacity =
                MAT_OPACITY;
              currentTarget.children[0].children[0].material.side =
                THREE.DoubleSide;
            } else {
              currentTarget.children[0].name = TARGETS[i].name;
              currentTarget.children[0].material.color.set(0xfff500);
              currentTarget.children[0].material.transparent = true;
              currentTarget.children[0].material.opacity = MAT_OPACITY;
              currentTarget.children[0].material.side = THREE.DoubleSide;
            }

            let targetPosition;
            if (!gui.__folders["Target " + TARGETS[i].name]) {
              targetPosition = gui.addFolder("Target " + TARGETS[i].name);
            } else {
              targetPosition = gui.__folders["Target " + TARGETS[i].name];
            }
            currentTarget.position.x = model.position.x;
            currentTarget.position.y = model.position.y;
            currentTarget.position.z = model.position.z;
            currentTarget.scale.x = model.scale;
            currentTarget.scale.y = model.scale;
            //make calculator twice as big
            if (TARGETS[i].name == "calculette") {
              currentTarget.scale.y *= 2;
            }

            targetPosition
              .add(currentTarget.position, "x")
              .min(-2)
              .max(2)
              .step(0.0001);
            targetPosition
              .add(currentTarget.position, "y")
              .min(-2)
              .max(2)
              .step(0.0001);
            targetPosition
              .add(currentTarget.position, "z")
              .min(-2)
              .max(2)
              .step(0.0001);

            targetPosition
              .add(currentTarget.scale, "x")
              .min(0)
              .max(2)
              .step(0.0001);
            targetPosition
              .add(currentTarget.scale, "y")
              .min(0)
              .max(2)
              .step(0.0001);
            targetPosition
              .add(currentTarget.scale, "z")
              .min(0)
              .max(2)
              .step(0.0001);
          },
          undefined,
          function (error) {
            console.log("error", error);
          }
        );
      });
    });
  }
</script>

<style>
  canvas {
    position: absolute;
    top: 0;
    left: 0;
  }
  button {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 50;
    font-size: 15px;
    padding: 3px;
    margin: 15px;
  }
</style>
